module.exports = __webpack_public_path__ + "assets/img/hov_btn_Android-377380a6.png";